import React, { useContext, useEffect, useState, useCallback } from "react";

import "./stylesPromotionsManagement.css";
import Layout from "../../CommonComponents/Layout/Layout";

import AppContext from "../../../context/AppContext";
import { SIDER_TABS } from "../../../utils/Constants";

import PurchaseIcon from "../../../assets/icons/ic_purchase-match.svg";
import { Plus } from "react-feather";
import PurchasesByType from "./PurchasesByType/PurchasesByType";
import Purchases from "./Purchases/Purchases";
import CustomDatePicker from "../../CommonComponents/CustomDatePicker/CustomDatePicker";

import dayjs from "dayjs";
import CustomAutoComplete from "../../CommonComponents/CustomAutoComplete/CustomAutoComplete";
import { Select, Table } from "antd";
import { CaretDownOutlined, CaretUpOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import createPrivateAdminPanelInstance from "../../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../../api/ApiRoutes";

function PromotionsManagement() {
  const navigate = useNavigate();

  const { setActiveSidebarTab } = useContext(AppContext);
  const token = JSON.parse(localStorage.getItem("token"));
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(token?.IdToken, true);

  const todayRange = [dayjs(), dayjs()];
  const [dates, setDates] = useState(todayRange);
  const [isApiRunning, setIsApiRunning] = useState(false);
  const [dashboardData, setDashboardData] = useState({
    purchases: 0,
    players_received: 0,
    players_used: 0,
    purchases_by_type: {
      purchase_match: 0,
      free_bet: 0,
      free_squares: 0,
      profit_boost: 0,
      insurance_bets: 0
    }
  });

  console.log(dashboardData, "dashboardData");

  const fetchDashboardData = async () => {
    setIsApiRunning(true);
    try {
      const response = await PrivateAdminPanelInstance.get(
        API_ROUTES.GET_PROMOTIONS_DASHBOARD,
        {
          params: {
            start_date: dates[0].format('YYYY-MM-DD'),
            end_date: dates[1].format('YYYY-MM-DD')
          }
        }
      );
      console.log(response, "response");
      
      if (response?.data?.success) {
        setDashboardData(response?.data?.data);
      }
    } catch (error) {
      console.error("Error fetching promotions dashboard data:", error);
    } finally {
      setIsApiRunning(false);
    }
  };

  useEffect(() => {
    if (dates && dates[0] && dates[1]) {
      fetchDashboardData();
    }
  }, [dates]);

  const tableHeaders = [
    "Active",
    "Not Started",
    "Suspended",
    "Finished",
    "Drafts",
    "Archived",
  ];

  const [selectedTableHeader, setSelectedTableHeader] = useState(
    tableHeaders[0]
  );

  const promotions = [
    { id: 1, label: "Promotion 1", value: "Promotion 1" },
    { id: 2, label: "Promotion 2", value: "Promotion 2" },
    { id: 3, label: "Promotion 3", value: "Promotion 3" },
    { id: 4, label: "Promotion 4", value: "Promotion 4" },
    { id: 5, label: "Promotion 5", value: "Promotion 5" },
    { id: 6, label: "Promotion 6", value: "Promotion 6" },
  ];

  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      sorter: (a, b) => a.id - b.id,
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => a.name.localeCompare(b.name),
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
      sorter: (a, b) => a.type.localeCompare(b.type),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      sorter: (a, b) => a.status.localeCompare(b.status),
      render: (text) => (
        <span className={`status ${text.toLowerCase()}`}>{text}</span>
      ),
    },
    {
      title: "Start Date",
      dataIndex: "startDate",
      key: "startDate",
      sorter: (a, b) => new Date(a.startDate) - new Date(b.startDate),
    },
    {
      title: "End Date",
      dataIndex: "endDate",
      key: "endDate",
      sorter: (a, b) => new Date(a.endDate) - new Date(b.endDate),
    },
    {
      title: "Profit",
      dataIndex: "profit",
      key: "profit",
      sorter: (a, b) => a.profit - b.profit,
      render: (value) => (
        <span style={{ display: "flex", alignItems: "center", gap: "5px" }}>
          {value.toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
          })}
          <p className="up">
            <CaretUpOutlined /> 15%
          </p>
        </span>
      ),
    },
    {
      title: "Volume",
      dataIndex: "volume",
      key: "volume",
      sorter: (a, b) => a.volume - b.volume,
      render: (value) => (
        <span style={{ display: "flex", alignItems: "center", gap: "5px" }}>
          {value.toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
          })}
          <p className="down">
            <CaretDownOutlined /> 10%
          </p>
        </span>
      ),
    },
    {
      title: "Wagered",
      dataIndex: "wagered",
      key: "wagered",
      sorter: (a, b) => a.wagered - b.wagered,
      render: (value) => (
        <span style={{ display: "flex", alignItems: "center", gap: "5px" }}>
          {value.toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
          })}
          <p className="down">
            <CaretDownOutlined /> 5%
          </p>
        </span>
      ),
    },
    {
      title: "Paid out",
      dataIndex: "paidout",
      key: "paidout",
      sorter: (a, b) => a.paidout - b.paidout,
      render: (value) => (
        <span style={{ display: "flex", alignItems: "center", gap: "5px" }}>
          {value.toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
          })}
          <p className="up">
            {" "}
            <CaretUpOutlined /> 10%
          </p>
        </span>
      ),
    },
    {
      title: "Received",
      dataIndex: "received",
      key: "received",
      sorter: (a, b) => a.received - b.received,
      render: (value) =>
        value.toLocaleString("en-US", {
          style: "currency",
          currency: "USD",
        }),
    },
    {
      title: "Activated",
      dataIndex: "activated",
      key: "activated",
      sorter: (a, b) => a.activated - b.activated,
      render: (value) => (value ? "Yes" : "No"),
    },
  ];

  const dataSource = Array.from({ length: 100 }, (_, index) => ({
    key: index + 1,
    id: index + 1,
    name: `Campaign ${index + 1}`,
    type: ["Bonus", "Cashback", "Free Bet"][index % 3],
    status: Math.random() > 0.5 ? "Active" : "Inactive",
    startDate: `2023-09-${String((index % 28) + 1).padStart(2, "0")}`,
    endDate: `2023-10-${String((index % 28) + 1).padStart(2, "0")}`,
    profit: Math.floor(Math.random() * 20000) - 10000,
    volume: Math.floor(Math.random() * 100000) + 5000,
    wagered: Math.floor(Math.random() * 90000) + 1000,
    paidout: Math.floor(Math.random() * 70000) + 2000,
    received: Math.floor(Math.random() * 60000) + 3000,
    activated: Math.random() > 0.5,
  }));

  const handleRowClick = (record) => {
    const campaignSlug = record.name.replace(/\s+/g, "-").toLowerCase();
    navigate(`/promotions-management/campaign/${campaignSlug}`);
  };

  useEffect(() => {
    setActiveSidebarTab(SIDER_TABS.PROMOTIONS, "Management");
  }, []);

  return (
    <Layout>
      <div className="promotions-management-container">
        <div className="promotions-management">
          <>
            <div className="head-controls">
              <div className="header-text-container">
                <p className="header-text">Promotions Management</p>
              </div>
            </div>
            <div className="promotions-management-content">
              <div className="promotions-management-content-header">
                <img src={PurchaseIcon} alt="Purchase icon" />
                <h2>Create New Promo/Notification</h2>
                <p>
                  Create a new multi channel messaging campaign with the ability
                  to add/send a promotion
                </p>
                <div
                  className="plus-icon"
                  onClick={() => {
                    navigate("/promotions-management/new-promotion");
                  }}
                >
                  <Plus size={20} />
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div className="h2-container">
                  <h2>All Promotions</h2>
                  <p>16 Active</p>
                </div>
                <CustomDatePicker
                  getData={fetchDashboardData}
                  dates={dates}
                  setDates={setDates}
                  showPresets={true}
                />
              </div>
              <Purchases isApiRunning={isApiRunning} dashboardData={dashboardData} />
              <PurchasesByType isApiRunning={isApiRunning} dashboardData={dashboardData} />
              <div className="promotions-management-table-container">
                <div className="promotions-management-table-container-header">
                  <h2>All Promotions</h2>
                  <CustomDatePicker
                    getData={() => {}}
                    dates={dates}
                    setDates={setDates}
                    showPresets={true}
                  />
                </div>
                <div className="promotions-management-selector-container">
                  <div className="promotions-management-selector">
                    <Select
                      mode="single"
                      placeholder="Search by ID"
                      onChange={() => {}}
                      options={promotions}
                    />
                  </div>
                  <CustomAutoComplete
                    placeholder="Search"
                    allOptions={promotions}
                    handleChange={() => {}}
                    clearOptions={() => {}}
                  />
                </div>
                <div className="promotions-management-table">
                  <div className="table-headers">
                    {tableHeaders.map((header, index) => (
                      <div
                        key={index}
                        className={`table-header ${
                          selectedTableHeader === header ? "active" : ""
                        }`}
                        onClick={() => setSelectedTableHeader(header)}
                      >
                        <p>{header}</p>
                      </div>
                    ))}
                  </div>
                  <Table
                    dataSource={dataSource}
                    columns={columns}
                    scroll={{ x: 1700 }}
                    onRow={(record) => {
                      return {
                        onClick: () => handleRowClick(record), // clique na linha
                      };
                    }}
                  />
                </div>
              </div>
            </div>
          </>
        </div>
      </div>
    </Layout>
  );
}

export default PromotionsManagement;
